'use client';

import { styled } from '@linaria/react';
import useTypewriter from '@fe-news/hooks/use-type-writer';
import Image from 'next/image';
import Link from 'next/link';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';

const TitleWrapper = styled.div`
  display: flex;
  padding: 16.5px 0px;
  height: 81px;

  &:not(:nth-child(2)) {
    border-bottom: 1px solid #e2e8f1;
  }
`;

const H1 = styled.p`
  color: #383838;
  font-size: 19px;
  line-height: 1.53;
  letter-spacing: 0.5px;
  text-align: left;
  margin-left: 16px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (min-width: ${SCREEN_SIZE.DESKTOP}px) {
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: normal;
  }
`;

const Cursor = styled.span`
  display: inline-block;
  width: 4px;
  height: 12px;
  background-color: #848d97;
  margin-left: 2px;
  animation: blink 0.5s step-end infinite;

  @keyframes blink {
    50% {
      opacity: 0;
    }
  }
`;

type ArticleTitleProps = {
  title: string;
  url: string | null;
};

const ArticleTitle = ({ title, url }: ArticleTitleProps) => {
  const { displayText, isCursor } = useTypewriter({ content: title });

  return (
    <TitleWrapper>
      <Image src='/assets/icons/icon-ai-robot.svg' alt='ai-robot' width={30} height={30} />
      <Link href={url ?? '/'} prefetch={false}>
        <H1>
          {displayText}
          {isCursor && <Cursor />}
        </H1>
      </Link>
    </TitleWrapper>
  );
};

export default ArticleTitle;
